import {
  NotificationApi,
  NotifikaciaHistoria as NotifikaciaHistoriaGenerated,
  NotifikaciaHistoriaPage as NotifikaciaHistoriaPageGenerated,
  SortDirectionEnum,
} from 'evidencna-aplikacia-frontend-ts-axios';
import { ClientResponse } from '../../../model/ClientResponse';
import apiConfiguration from '../../configuration/apiConfiguration';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';
import NotifikaciaHistoriaPage from '../../../model/notifikacia/NotifikaciaHistoriaPage';
import NotifikaciaHistoria from '../../../model/notifikacia/NotifikaciaHistoria';
import { NotifikaciaTypEnum, notifikaciaTypNazov } from '../../../model/notifikacia/NotifikaciaTyp';
import Uuid from '../../../model/Uuid';

const client = new NotificationApi(apiConfiguration(evidenciaPrefixPath));

export const mapNotifikacia = (data: NotifikaciaHistoriaGenerated): NotifikaciaHistoria => ({
  ...data,
  typ: data.typ ? notifikaciaTypNazov(NotifikaciaTypEnum[data.typ] || data.typ) : null,
  datumOdoslania: data.datumOdoslania ? new Date(data.datumOdoslania) : null,
});

const map = (data: NotifikaciaHistoriaPageGenerated): NotifikaciaHistoriaPage => ({
  ...data,
  notifikaciaHistoriaList: (data.notifikaciaHistoriaList || [])
    .map(notifikacia => mapNotifikacia(notifikacia)),
});

// eslint-disable-next-line import/prefer-default-export
export const fetchNotifikaciaHistoriaList = async (
  materialUuid: Uuid,
  page?: number,
  size?: number,
  sortBy?: string,
  sortDirection?: SortDirectionEnum,
  headers?: object,
):
  Promise<ClientResponse<NotifikaciaHistoriaPage>> => {
  const {
    data,
    status,
  } = await client.getNotificationHistoriaList(
    materialUuid,
    page,
    size,
    sortBy,
    sortDirection,
    headers,
  );
  return {
    data: map(data),
    responseCode: status,
  };
};
